import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Field } from 'react-final-form';
import { withAsyncActions } from 'react-async-client';
import { Button, Spin } from 'antd';
import Translate from 'react-translate-component';
import { path } from 'ramda';
import * as yup from 'yup';

import withAutoFocusForm from 'components/hocs/withAutoFocusForm';
import withFormWrapper from 'components/hocs/withFormWrapper';
import { withRouteOptions } from 'components/hocs/withRouteOptions';
import { login } from 'constants/routes';
import { getPasswordCheck } from 'actions/asyncActions';
import { passwordConfirm } from 'actions/userActions';
import ErrorHTML from 'components/common/form/ErrorHTML';
import GuestInput from 'components/common/form/GuestInput';
import GuestFooter from 'components/layout/guest/GuestFooter';

const getAuthToken = path(['match', 'params', 'authToken']);

const stateToProps = (state, props) => ({
    initialValues: {
        authKey: getAuthToken(props)
    }
});

const validationSchema = yup.object().shape({
    password: yup.string()
                .match('repeat', 'passwordsMustMatch')
                .range(6, 15, 'passwordLength')
                .required(),
    repeat: yup.string()
                .match('password', 'passwordsMustMatch')
                .range(6, 15, 'passwordLength')
                .required()
});

@withAutoFocusForm
@connect(stateToProps)
@withAsyncActions({
    formAction: passwordConfirm,
    getPasswordCheck: getPasswordCheck
        .withPayload((props) => props.initialValues.authKey)
        .withOptions({ dispatchOnMount: true })
})
@withFormWrapper({
    validationSchema,
    mapPropsToValues: props => props.initialValues
})
@withRouteOptions
export default class ResetView extends Component {
    static propTypes = {
        formAction: PropTypes.object.isRequired,
        getPasswordCheck: PropTypes.object.isRequired
    };

    static routeOptions = {
        title: 'guest.recoveryPage'
    };

    render() {
        const { formAction: { meta }, getPasswordCheck: { meta: check } } = this.props;

        if (check.error) {
            return (
                <Fragment>
                    <Translate content="guest.invalidResetToken" />
                    <GuestFooter>
                        <Link to={login.path}>
                            <Translate content="guest.toLogin" />
                        </Link>
                    </GuestFooter>
                </Fragment>
            );
        }

        return (
            <Fragment>
                <Spin spinning={Boolean(meta.pending)}>
                    { meta.error && (
                        <ErrorHTML meta={meta} className='guest-layout-error' />
                    )}

                    <Field
                        name="password"
                        component={GuestInput}
                        type="password"
                        placeholder="profile.form.newPassword"
                        notWrap
                    />

                    <Field
                        name="repeat"
                        component={GuestInput}
                        type="password"
                        placeholder="profile.form.passwordRepeat"
                        notWrap
                    />

                    <Button htmlType="submit" type="primary" size="large" className="login-form-button">
                        <Translate content="guest.reset" />
                    </Button>
                </Spin>
                <GuestFooter />
            </Fragment>
        );
    }
}
